import type { PlainMessage } from '@bufbuild/protobuf';

import {
  NoteTeethGranularity,
  type NoteTeethBlock,
} from '@/shared/api/protocol-ts/model/dto_scribe_catalog_pb';

// Scribe's `NoteBlock.TeethHaveMarks`: a teeth field that stores marks, one
// with tooth codes, the surface granularity or a number per tooth. A block
// written before tooth codes existed may carry no codes at all.
export const noteTeethHaveMarks = ({
  Codes,
  Granularity,
  Unit,
}: Pick<PlainMessage<NoteTeethBlock>, 'Codes' | 'Granularity' | 'Unit'>) =>
  !!Codes?.length ||
  Granularity === NoteTeethGranularity.NoteTeethGranularitySurface ||
  !!Unit;
